import { createSvgIcon } from "@mui/material";

export default createSvgIcon(
  <svg
    width={19}
    height={19}
    viewBox="0 0 19 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Group 10">
      <rect
        id="Rectangle 54"
        y="11.0883"
        width={5}
        height="7.41176"
        fill="#222A5C"
      />
      <rect
        id="Rectangle 55"
        x={7}
        y="5.79413"
        width={5}
        height="12.7059"
        fill="#222A5C"
      />
      <rect
        id="Rectangle 56"
        x={14}
        y="0.5"
        width={5}
        height={18}
        fill="#222A5C"
      />
    </g>
  </svg>,
  "UsageFilled"
);
